<!-- A generalizable input for a new channel name with validators and all -->
<template>
  <donut-form-input
    v-model="channelNameValid"
    class="pos-rel"
    :for="channelName"
    :name="inputName"
    :validators="validators"
    :validate-immediately="!!modelValue"
  >
    <div :class="`pos-abs left-x1 top-11 t ${channelNameValid ? '' : 'red'}`">#</div>
    <input
      v-model="channelName"
      class="p-l20"
      type="text"
      :placeholder="props.placeholder"
      :name="inputName"
      required="true"
    >
  </donut-form-input>
</template>

<script setup>
  import { ref, computed, watch } from 'vue';
  import useValidators from 'composables/validators';
  import useSearchCaching from 'composables/search-caching';

  const props = defineProps({
    modelValue: { type: String, default: '' },
    placeholder: { type: String, default: 'new-channel' },
    inputName: { type: String, default: null },
  });
  const emit = defineEmits(['update:modelValue', 'updateIsValid']);

  const channelName = computed({
    get() { return props.modelValue; },
    set(value) { emit('update:modelValue', value); },
  });
  const { cacheValueAtFullPath } = useSearchCaching({
    query: channelName,
    basePath: '/channels/search_match',
  });
  const channelNameValid = ref(false);
  // availabilityValidator happens on a slight delay, so make sure the cacheValueAtFullPath is complete before declaring the name officially valid
  const channelNameConfirmedValid = computed(() => channelNameValid.value && cacheValueAtFullPath.value?.status === 'complete');
  const { presenceValidator, slackChannelNameRestrictionValidator, availabilityValidator } = useValidators();
  const validators = computed(() => [
      presenceValidator('A channel name'),
      slackChannelNameRestrictionValidator(),
      availabilityValidator(cacheValueAtFullPath.value, 'A channel with this name'),
    ]);

  watch(channelNameConfirmedValid, (newVal) => {
    emit('updateIsValid', newVal);
  });
</script>
